import { reactive, computed } from '@vue/composition-api'
import * as _ from 'lodash'

export const ContractAdministratorTransfer = (props, context) => {
  const store = context.root.$store
  const { contract, profile } = store.state
  store.dispatch('contract/getContractData')

  const state = reactive({
    loginUserId: profile.id,
    users: computed(() => store.getters['users/sortedLoginIdAndAuth']),
    isAccountLogin: computed(() => store.getters['profile/isAccountLogin']),
    max: computed(() => contract.admin_number_max),
    isMax: computed(() => state.checkBox.length >= state.max),
    canSubmit: computed(() => state.checkBox.length > state.max),
    checkBox: [],
    searchKeyword: '',
    searchKeywordCommit: '',
    search: () => {
      state.searchKeywordCommit = state.searchKeyword.replace(/[\s　]/g, '')
    },
    filterdUser: computed(() => {
      return _.filter(state.users, user => {
        return !state.searchKeywordCommit || user.name.replace(/[\s　]/g, '').indexOf(state.searchKeywordCommit) > -1
      })
    }),
    // 変更した利用者のみにフィルタリング
    editAccount: computed(() => {
      const differenceUsers = _.filter(store.getters['users/sortedLoginIdAndAuth'], user => {
        return (user.auth === 0 && _.includes(state.checkBox, user.id)) ||
          (user.auth !== 0 && !_.includes(state.checkBox, user.id))
      })

      return _.map(differenceUsers, user => {
        return { id: user.id, auth: _.includes(state.checkBox, user.id) ? 1 : 0 }
      })
    })
  })

  // 管理者権限をもつユーザーを初期チェック済みに設定
  state.checkBox = _.map(_.filter(state.users, user => user.auth !== 0), user => user.id)

  const close = () => {
    context.emit('close')
  }

  const submit = () => {
    context.emit('submit', state.editAccount)
  }

  const openContractAccountDetail = () => {
    context.emit('openContractAccountDetail')
  }

  return {
    close,
    submit,
    openContractAccountDetail,
    state
  }
}
